import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Observable, map } from 'rxjs';
import {ConnectionService} from "../../../../shared/services/connection.service";
import {IomModuleService} from "../../../../shared/services/iom-module.service";
import { RnimuQuizModule } from '@rsmu/quiz';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-quiz-page',
    templateUrl: './quiz-page.component.html',
    styleUrls: ['./quiz-page.component.scss'],
    standalone: true,
    imports: [NgIf, RnimuQuizModule, AsyncPipe]
})
export class QuizPageComponent implements OnInit {

  variantId$?: Observable<string>;

  get backUrl() {
    return this.iom.backUrl;
  }
  get connectionRestored$() {
    return this.connection.connectionRestored$
  }
  get connectionLost$() {
    return this.connection.connectionLost$
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private connection: ConnectionService,
    private iom: IomModuleService
  ) {}

  ngOnInit(): void {

  this.variantId$ = this.activatedRoute.params
    .pipe(
      map(params => {
        const { quizId } = params;
        return quizId as string
    }))
  }
}
